import { CardText } from 'material-ui';
import {combineForms} from 'react-redux-form';

const loginForm = {
    userId: '',
    password: ''
};

const feedback = {
    feedback: ''
};

const updatePasswordForm = {
    oldPassword: '',
    newPassword: ''
};

const createUserForm = {
    accessLevel: '',
    email: '',
    firstName: '',
    jobDesc: '',
    jobTitle: '',
    lastName: '',
    middleName: '',
    modules: '',
    password: '',
    organization: '',
    userId: ''
};

const updateUserForm = {
    accessLevel: '',
    email: '',
    firstName: '',
    jobDesc: '',
    jobTitle: '',
    lastName: '',
    middleName: '',
    organization: '',
    modules: ''
};

const selectedListItems = {
    listItems: []
};

const mcqForm = {};

const moduleForm = {
    moduleName: '',
    category : '',
    subcategory : '',
    moduleType: 'Training Module',
    Instructions: ''
};

const createOrgForm = {
    OrganizationName: '',
    Category: [],
    SubCategory: []
};

const updateOrgForm = {
    OrganizationName: '',
    Category: [],
    SubCategory: []
};

const categoryFilterForm = {
    Category: '',
    SubCategory: ''
}

export const forms = combineForms({
    createUserForm, updateUserForm, feedback, moduleForm, selectedListItems, updatePasswordForm, mcqForm, createOrgForm, updateOrgForm, categoryFilterForm
}, 'forms');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/formReducer.ts